import React, {Component} from 'react';

import axios from 'axios';
import auth0Client from '../Auth';
import {withRouter} from 'react-router-dom';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import {ToastContainer, ToastStore} from 'react-toasts';
import LostItemFunctions from '../LostItem/LostItemFunctions';
import {SERVER_URL}  from '../Constants';
import moment from 'moment'
import Modal from 'react-responsive-modal';
import Cookies from 'universal-cookie';
import ReactImageMagnify from 'react-image-magnify';
import filterFactory, { textFilter, numberFilter } from "react-bootstrap-table2-filter";
import Toggle from "react-toggle-component"
import DatePicker from "react-datepicker";
import ParcelPayment from './ParcelPayment';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import {LOCAL_URL} from '../Constants';

import ParcelPaymentManager from './ParcelPaymentManager';
const { SearchBar } = Search;
const cookies = new Cookies();
const defaultSorted = [{
    dataField: 'dateReceived',
    order: 'asc'
  }];
const FILTER_COOKIE_NAME = 'initialSRItemsFilter';
const HIDE_IMAGES_COOKIE = 'hideImagesSRItems'
const paginationOption = {
    custom: true,
    sizePerPage: 100
  };

  function imageFormat(cell, row){
    if (row.picUrl){
        return (
            <img  src={row.picUrl} width={150} height={150} alt={row.id} />
        )
    }else{
      return (
        <img  src='../default-placeholder.png' width={50} alt={row.id} />
    )
    }
}
function formatParcelLabel(cell,row){
  if (cell){
    let str = (cell.length > 200)? cell.substr(0,200) + '...' : cell.substr(cell, cell.length);
    return (
     <small>{str}</small>
    )
  }
}
function formatGroupNum(cell,row){
  if (row.parcelGroupNum){
    var parcelGroupNum = (row.parcelGroupNum!== undefined) ? row.parcelGroupNum : '---';
    var parcelGroupTotalCount = (row.parcelGroupTotalCount!== undefined) ? row.parcelGroupTotalCount : '---';
    return  parcelGroupNum + ' of ' + parcelGroupTotalCount
  }


}
function getDaysSinceReceived(dateReceived){
  if (dateReceived){
    var a = moment(new Date(dateReceived));
    var b = moment(new Date());
   return b.diff(a, 'days') // 1
  }else{
    return 'ERROR: Missing';
  }
}
function statusFormatter(cell,row){
  if (row.statusCd==='I'){
    return (<h6 className="text-info">IN STORAGE</h6>);
  }else if (row.statusCd==='GP'){
    return (<h6 className="text-success">GUEST PICKUP</h6>);
  }else if (row.statusCd==='SB'){
    return (<h6 className="text-success" >SENT BACK</h6>);
  }else if (row.statusCd==='A'){
    return (<h6 className="text-primary">ARCHIVE</h6>);
  }else if (row.statusCd==='D'){
    return (<h6 className="text-success">GUEST DELIVERED</h6>);
  }


}

function afterFilter(newResult, newFilters) {
  console.log(newResult);
  console.log(newFilters);
}

/*function safetyClass(cell,row){
  var difInDays =0;
  
  if (row.dateReceived){
    difInDays = getDaysSinceReceived(row.dateReceived);
    if (difInDays <= 3){
      return "text-primary text-center";
    }else{
      return "text-primary text-center"
    }
  }else{
    return "text-primary text-center"
  }
}

function safetyWarning(cell,row){
  var difInDays =0;
  
  if (row.safetyWarning){
  
      return (<span className="badge badge-pill badge-danger">** DISINFECT REQUIRED **</span>);//"** DISINFECT REQUIRED **"
    }else{
      return "";
    }
  
}

function statusColFormater(cell, row) {
  var difInDays =0;
  if (row.statusCd==='GP'){
    return "table-success text-primary text-center"
  }
  if (row.statusCd==='A'){
    return "text-primary text-center"
  }
  if (row.dateReceived){
    difInDays = getDaysSinceReceived(row.dateReceived);
    if (difInDays <= 7){
      return "table-success text-primary text-center"
    }else if (difInDays > 7 && difInDays <=30){
      return "table-warning text-primary text-center";
    }else if (difInDays > 30){
      return "table-danger text-primary text-center";
    }else{
      return "";
    }
  }else{
    return "table-danger text-primary text-center";
  }
  
  //return ({'background-color':'red'});

}
*/


// Create the component
class SRItems extends Component{

     constructor(props){
         super(props);

         let initialSRItemsFilter= cookies.get(FILTER_COOKIE_NAME);

         let defaultFilter = (initialSRItemsFilter) ? initialSRItemsFilter:'';
        // console.log('hideimages Cookie Val:' + cookies.get(HIDE_IMAGES_COOKIE));
         this.state = {
            allItems:[],
            filteredItems:[],
            refreshButtonText:'Refresh',
            displayLargeImageModal: false,
            selectedImageUrl:'',
            filter:defaultFilter,
            selectedRows:[],
            useColumnFilters:(cookies.get('useParcelColumnFilters')==='true') ? true : false,
            hideImages:(cookies.get(HIDE_IMAGES_COOKIE)==='true') ? true : false,
            actionButtonDisabled : true,
            displayReturnToGuest:false,
            batchUpdatedNote:'',
            guestPickupDate:new Date(),
            checkedCount:0,
            linkOptions:[],
            displayLinkOptionsModal:false,
            selectedLinkItem:{},
            acceptParcelPayment:true,
           parcelsToReturn:[],
           displayBatchUpdateModal:false,
           batchUpdateParcelRef:'',
           bacthUpdateGroupName:'',
           parcelsToUpdate:[],
           supportActions:true,
          
           distinctGroupNames:[],
           selectedAction:'',  //Used to reset the UI state after an action is selected
           enablePTBulkUpdates:false,
           displayMarkAsPaidModal:false,
           parcelsToMarkAsPaid:[],
           paidDate:new Date()
        }
        this.tableRef = React.createRef();
        this.rowEvents = {
            onClick: (e, row, rowIndex) => {
              if (e.target.tagName.toLowerCase() === 'img'){return;}   
              if (e.target.hasChildNodes()){
                if (e.target.childNodes[0].type==='checkbox'){
                  //console.log('ignore');
                  return;
                }
              }
              this.setState({
                srItem: row,
                })
             
              if (e.target.type==='checkbox') {return;}
              if (auth0Client.getActiveVenuedId()===row.venueId){
                this.props.history.push('/SRItem/' + row.id);
              }
             
            },
            
          };
      
          axios.interceptors.response.use(response => {
            return response;
          }, error => {
           if (error.response.status === 401) {
            ToastStore.error("error unauthorized.  Your session has expired. Please log in again");
            
           }
          
      
           return error;
          });

};



async componentDidMount(){
    try {
        const venueTypeCd = auth0Client.getDefaultVenue().venueTypeCd;
        const acceptParcelPayment = auth0Client.getDefaultVenue().acceptParcelPayment;
        const enablePTBulkUpdates = auth0Client.getDefaultVenue().enablePTBulkUpdates;
        //console.log("Configured to accept Parcel payments: " + acceptParcelPayment);
        //console.log("Configured to enable PT Bulk Updates: " + enablePTBulkUpdates);
        // set venueTypeCode
        this.setState({
          venueTypeCd: venueTypeCd,
          acceptParcelPayment:acceptParcelPayment,
          enablePTBulkUpdates:enablePTBulkUpdates,
          supportActions:enablePTBulkUpdates
        })
  
      
        this.loadSRItems();
        this.loadLinkOptions();
        this.loadGroupNames();
        }
          catch(e){
            ToastStore.error(e.message);
          }
      
}
loadGroupNames=async()=>{
  //
  let groupNames =(await axios.post(`${SERVER_URL}/SR/distinctgroups/`,{}, {headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`, 'venueId': auth0Client.getActiveVenuedId()  }})).data; 
  //console.log(groupNames);
  // iterate through results and select the groupName 
  let uniqueGroupNamesList = [];
  for (var i=0; i<groupNames.length; i++){
    uniqueGroupNamesList.push(groupNames[i].groupName);
    
  }
  this.setState({distinctGroupNames:uniqueGroupNamesList});

}
ageInDays=(dateReceived)=>{
  try {
    if(dateReceived){
      const today = new Date();
      var res = Math.abs(today - new Date(dateReceived)) / 1000;

      var days = Math.floor(res / 86400);
      return days;
    }
  } catch(e){
      return '';
  }
  
}

isSafetyWarning=(dateReceived, statusCd)=>{
  var difInDays =0;
  
  if (dateReceived){
    difInDays = getDaysSinceReceived(dateReceived);
    return (difInDays <= 3 && statusCd==='I');
  }else{
    return "";
  }
}


loadLinkOptions=()=>{
  
  axios.post(SERVER_URL +  '/SR/linkoptions/',{},{  
    headers: { 
      'Authorization': `Bearer ${auth0Client.getIdToken()}`,
      'venueId': auth0Client.getActiveVenuedId() 
    }
  }).then((res)=>{
   
    if (res.status !==200) {
      //place your reentry code
      console.log("Error" + res.status);
      ToastStore.error("An error occured. Please try again: Not authorized");
      this.setState({
        linkOptions: []
    })
     }else{
        const SRItems = res.data;
        
        this.setState({
            linkOptions: SRItems,
          
        });
   
     }
    }).catch((e)=>{ 
        ToastStore.error("An error occured. Please try again: " + e.message);
      });

}

loadSRItems = ()=>{
  this.cleanSelectedCheckboxes();
    this.setState({refreshButtonText:'Loading...'});

    axios.get(SERVER_URL +  '/SR',{
        headers: { 
          'Authorization': `Bearer ${auth0Client.getIdToken()}`,
          'venueId': auth0Client.getActiveVenuedId() 
        }
      }).then((res)=>{
        this.setState({refreshButtonText:'Refresh'});
        if (res.status !==200) {
          //place your reentry code
          console.log("Error" + res);
          ToastStore.error("An error occured. Please try again: Not authorized.  Please check your subscription");
          this.setState({
            allItems: [],
            filteredItems: []
        })
         }else{
            const SRItems = res.data;
            for (var i=0; i<SRItems.length; i++){
              SRItems[i].age =this.ageInDays(SRItems[i].dateReceived);
              SRItems[i].safetyWarning =this.isSafetyWarning(SRItems[i].dateReceived, SRItems[i].statusCd);
            };
            this.setState({
                allItems: SRItems,
                //filteredItems: SRItems
            });
            this.applyFilter(this.state.filter);
         }
        }).catch((e)=>{ 
            //console.log("error " + e)
            this.setState({refreshButtonText:'Refresh'});
            ToastStore.error("An error occured. Please try again: " + e.message);
          });

}


filterButtonClick=(event)=>{

  // Select case

  
  const target = event.target;
  //console.log(target.id);
  target.checked=false;
  var filter = 'A';
  switch(target.id){
    case 'optArchive': filter = 'A'; break;
    case 'optShippedBack':filter = 'SB'; break;
    case 'optGuestReturn':filter = 'GP'; break;
    case 'optInStorage':filter = 'I'; break;
    case 'optAll':filter = ''; break;
    case 'optDelivered':filter = 'D'; break;
    default: filter = '';

  
  }
    // remember MY selection for next time!
    if (cookies){
      console.log('setting user cooke:' + filter);
      cookies.set(FILTER_COOKIE_NAME, filter, { path: '/' });
    }
    this.setState({filter:filter});
  this.applyFilter(filter);

 return true;
}

applyFilter=(filter)=>{

  console.log('applying filter:' + filter);

  this.cleanSelectedCheckboxes();


  if (filter===''){
    var filteredItems = this.state.allItems.filter((item) =>{
      return item;
    });
    this.setState({
      filteredItems: filteredItems
    });

}else{

 filteredItems = this.state.allItems.filter((item) =>{
  if (item.statusCd === filter){
      return item;
    }else{
      return null;
    }
  });
 
  }
  
  this.setState({
    filteredItems: filteredItems,
    selectedRows:[]
  });
}

renderToast=()=>{
    return( <div>
             <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
            </div>);
  }
  renderLargeImage=()=>{

    return(
  
   
        <Modal open={this.state.displayLargeImageModal} onClose={()=>this.setState({displayLargeImageModal:false})} center>
            
            <ReactImageMagnify  style={{width:700, height:600}} enlargedImagePosition='over' {...{
                                    smallImage: {
                                        alt: 'image',
                                        isFluidWidth: false,
                                        src: this.state.selectedImageUrl,
                                        width:700,
                                        height:600
                                    },
                                    largeImage: {
                                      alt: 'image',
                                      src: this.state.selectedImageUrl,
                                        width: 1800,
                                        height: 1600
                                    },
                                    isHintEnabled: true,
                                    shouldHideHintAfterFirstActivation: false
                                }} />
            <button title="Close"    className="btn btn-info" onClick={()=>{this.setState({displayLargeImageModal:false})}}>Close </button>
        </Modal>
  
        )
  }

  renderBatchUpdateFields=()=>{
    return (
      <Modal open={this.state.displayBatchUpdateModal} onClose={()=>this.setState({displayBatchUpdateModal:false})} center>
          <div style={{width:'500px', height:'500px'}}>
            <h5>Batch Update Parcels</h5>
            <small>Each parcel will be assigned the following:</small>
            <hr/>
            <div className='row'>
              <div className='col-12 text-center'>
              <label htmlFor="bacthUpdateGroupName" className='text-primary'><b>Existing Groups:</b></label>

                <select className="form-control"  name="changeCd" onChange={(e) =>this.setState({bacthUpdateGroupName:e.target.value})}>
                  {
                    this.state.distinctGroupNames.map((item, index)=>{
                      return(
                        <option key={index} value={item}>{item}</option>
                      )
                    })
                  }
                </select>
                <br/>
                <label htmlFor="bacthUpdateGroupName" className='text-primary'><b>Group Name:</b></label>
                          <input
                                              disabled={this.state.disabled}
                                              type="text"
                                              onChange={this.handleInputChange}
                                              name="bacthUpdateGroupName"
                                              className="form-control"
                                              placeholder="Leave blank to not update"
                                              value= {this.state.bacthUpdateGroupName}
                                            />
              <br/>
            <label htmlFor="batchUpdateParcelRef" className='text-primary'><b>Reference #:</b></label>
                                 <input
                                              disabled={this.state.disabled}
                                              type="text"
                                              onChange={this.handleInputChange}
                                              name="batchUpdateParcelRef"
                                              className="form-control"
                                              placeholder="Leave blank to not update"
                                              value= {this.state.batchUpdateParcelRef}
                                            />       
                              
                <br/>
                
              </div>
            </div>
            <div className="row">
                      <div className="col-6 text-left">
                      
                      </div>
                      <div className="col-6 text-right">
                        <button className="btn btn-primary" onClick={()=>{this.updateBatchFields()}}>Update</button>
                      </div>
                    </div>

            

                </div>
        </Modal>
  
     );
    }
  onReturnedguestPickupDateChanged= date => this.setState({ guestPickupDate:date });



  handleInputChange=(event) =>{
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }
  updateBatchFields=()=>{

    if (!this.state.selectedRows || this.state.selectedRows.length<=0){
      alert('No parcels selected');
      return;
    };
    let ids= this.state.selectedRows;

    //if (this.state.bacthUpdateGroupName===undefined || this.state.bacthUpdateGroupName===''){
    //  alert('Please enter a group name');
    //  return;
    //}

    axios.post(SERVER_URL +  '/SR/batchUpdateFields',{
      ids:ids,
      groupName:this.state.bacthUpdateGroupName,
      parcelRef:this.state.batchUpdateParcelRef
     }, 
     {
      headers: { 
        'Authorization': `Bearer ${auth0Client.getIdToken()}`,
        'venueId': auth0Client.getActiveVenuedId() 
      }
    }).then((res)=>{
      
      if (res.status !== 200) {
        //place your reentry code
        console.log(res);
        ToastStore.error("An error occured. Please try again :" + res.body);
       
       }else{
        ToastStore.success('Parcel(s) Saved Successfully!');
        this.setState({bacthUpdateGroupName:'',batchUpdateParcelRef:'', displayBatchUpdateModal:false,  selectedAction:''},()=>{
          this.loadSRItems();
          this.loadGroupNames();
        });
        
       
         
       }
  
  
      // reload
       
  
      }).catch((e)=>{ 
        //console.log("error " + e)
        ToastStore.error("An error occured. " + e.message);
      });

  }


  batchUpdateGuestReturn=()=>{

  if (this.state.guestPickupDate===undefined){
    alert('Please enter a valid date');
    return;
  }
 
  if (this.state.changeCd!==undefined && this.state.changeCd!=='' ){
    this.setState({displayDonateDisposeModal:false, selectedAction:''});
    this.batchUpdate(this.state.selectedRows, this.state.changeCd);
  }
  
  

}



// batch update
batchUpdate=(ids, newStatusCd)=>{
  //  console.log('loading...' + auth0Client.getIdToken());
  
  if (ids.length<=0){
    alert('no parcels selected');
  }
  if (newStatusCd==='' || newStatusCd===undefined){
    alert('No status selected for batch update');
  }

  axios.post(SERVER_URL +  '/SR/RunBatch',{
    ids:ids,
    statusCd:newStatusCd,
    batchUpdatedNote:this.state.batchUpdatedNote,
    guestPickupDate:this.state.guestPickupDate,
    pickupName:this.state.pickupName
   }, 
   {
    headers: { 
      'Authorization': `Bearer ${auth0Client.getIdToken()}`,
      'venueId': auth0Client.getActiveVenuedId() 
    }
  }).then((res)=>{
    
    if (res.status !== 200) {
      //place your reentry code
      console.log(res);
      ToastStore.error("An error occured. Please try again :" + res.body);
     
     }else{
      ToastStore.success('Parcel(s) Saved Successfully!');
      this.setState({batchUpdatedNote:'', displayReturnToGuest:false, selectedAction:''});
      this.loadSRItems();
     
       
     }


    // reload
     

    }).catch((e)=>{ 
      //console.log("error " + e)
      ToastStore.error("An error occured. " + e.message);
    });

}




renderLinkOptions=()=>{
      return(
          <Modal open={this.state.displayLinkOptionsModal} onClose={()=>this.setState({displayLinkOptionsModal:false})} center>
              <div style={{width:'600px', height:'600px'}}>
                  <h5>Link the selected parcel(s)to:</h5>
                  <small></small>
                
                    <div className="row">
                      <div className="col-sm-12">

                       
                          <div className="radio">
                            
                            
                              <label className='text-info-emphasis'> <b>  &nbsp;   Choose an exciting parcel to link to </b> </label>
                              <ToolkitProvider 
                                        bootstrap4
                                        keyField='objectId' 
                                        data={ this.state.linkOptions } 
                                        columns={ 
                                          [   
                                            { dataField: 'id', hidden:true, text: 'Picture', formatter: imageFormat,align: 'center', headerStyle: {width:'0px', textAlign:'center', overflow: "hidden", textOverflow: 'ellipsis'} },
                                            { dataField: 'recipient',classes:'text-primary text-left', sort: true, text: 'Recipient', filterable:true, style:{fontWeight:'bold', cursor: 'pointer'},  textAlign: 'center', headerStyle: {width:'200px', overflow: "hidden", textOverflow: 'ellipsis'} },
                                            { dataField: 'groupName',classes:'text-primary text-left', sort: true, text: 'Group Name', filterable:true,  textAlign: 'left',style:{cursor: 'pointer'}, headerStyle: {width:'150px',  textAlign: 'center', overflow: "hidden", textOverflow: 'ellipsis'} },
                                            { dataField: 'barcodeValue',classes:'text-primary',formatter:this.formatLongString, sort: true, text: 'Tracking',filter: this.customTextFilter(), filterable:true, style:{cursor: 'pointer', wordWrap: 'break-word', display:'inline-block'}, textAlign: 'left',headerStyle: { width:'220px',overflow: "hidden", textOverflow: 'ellipsis'} },

                                          ]
                                        } 
                                        defaultSorted={[{
                                          dataField: 'name',
                                          order: 'asc'
                                        }]}
                                      

                                        search
                                        >
                                          {props => (
                                              <div>
                                                <div className='row '>
                                                      <div className='col-3 text-center' >
                                                          <SearchBar { ...props.searchProps } />
                                                      </div>
                                                  </div>
                                                  <div className='row '>
                                                      <div className='col-12 text-right' style={{ height: '400px', overflow: 'scroll' }}>
                                                      <BootstrapTable
                                                        maxHeight={"400px"}                                            
                                                        style={{ height: '400px',width:'600px', overflow: 'scroll' }}
                                                        className="table-sm"
                                                        ref={this.tableRef2}
                                                        striped
                                                        hover
                                                        condensed
                                                       
                                                        rowEvents={
                                                          {
                                                            onClick: (e, row, rowIndex) => {
                                                           
                                                              this.setState({
                                                                selectedLinkItem: row,
                                                                })
                                                             
                                                           
                                                            }
                                                            
                                                          }
                                                        }
                                                        
                                                        { ...props.baseProps }
                                                    
                                                      />
                                                      </div>

                                                  </div>
                                

                                            

                                            </div>

                                          )}

                                    </ToolkitProvider>
    
                          
                          </div>

                    

                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6 text-left">
                        <button className="btn btn-danger-outline" onClick={()=>{this.setState({displayLinkOptionsModal:false})}}>Cancel</button>
                      </div>
                      <div className="col-6 text-right">
                        <button className="btn btn-primary" onClick={()=>{this.setState({displayLinkOptionsModal:false})}}>Link</button>
                      </div>
                    </div>

              </div>
          </Modal>
      )


}

renderParcelPayment=()=>{
  return (
    <Modal open={this.state.displayReturnToGuest} onClose={()=>this.setState({displayReturnToGuest:false})} center>
      <ParcelPayment parcelItems={this.state.parcelsToReturn} />
    </Modal>
  )
}


renderGuestPickup=()=>{
    return (
      <Modal open={this.state.displayReturnToGuest} onClose={()=>this.setState({displayReturnToGuest:false})} center>
          <div style={{width:'500px', height:'500px'}}>
            <h5>Return To Recipient</h5>
            <small>Each parcel will be assigned the following:</small>
            <hr/>

            <br/>
            <label htmlFor="pickupName" className='text-primary'><b>Name:</b></label>
                          <input
                                              disabled={this.state.disabled}
                                              type="text"
                                              onChange={this.handleInputChange}
                                              name="pickupName"
                                              className="form-control"
                                              placeholder="Person picking up the parcel(s)"
                                              value= {this.state.pickupName}
                                            />

            <label htmlFor="returnToGuest" className='text-danger'><b>Date Returned To Guest:</b></label>
                                <br/>
                                  <DatePicker
                                  className="form-control"
                                    onChange={this.onReturnedguestPickupDateChanged}
                                    name="guestPickupDate"
                                    selected={this.state.guestPickupDate}
                                  />             
                              
                <br/>         
            <label htmlFor="batchUpdatedNote" className='text-primary'><b>Note:</b></label>
                          <input
                                              disabled={this.state.disabled}
                                              type="text"
                                              onChange={this.handleInputChange}
                                              name="batchUpdatedNote"
                                              className="form-control"
                                              placeholder="optional"
                                              value= {this.state.batchUpdatedNote}
                                            />
              <br/>
           


          </div>
          <div className='row'>

            <div className='col-12 text-center'>
              <button
                disabled={this.state.disabled}
                className="btn btn-success"
                onClick={() => {this.batchUpdateGuestReturn()}}>
                  Process Return- {this.state.selectedRows.length} Parcels
              </button>
            </div>
          </div>
       
    </Modal>  
    )
  }
 
  renderGrid=()=>{
    return (

      <div >
       
       
       {this.renderToast()}
       {this.state.filteredItems === null && <p>Loading ...</p>}
        <ToolkitProvider 
        bootstrap4
          keyField='id' 
          data={ this.state.filteredItems } 
          columns={ this.getColumns(this.state.venueTypeCd) } 
          
          defaultSorted={defaultSorted}
          search
          >
          {
    props => (
      <div>
       
        <SearchBar { ...props.searchProps } />
        <hr />
        <BootstrapTable
         className="table-sm"
          striped
          hover
          condensed
          filter={ filterFactory({afterFilter}) }  
          rowEvents={this.rowEvents}
          selectRow={ { 
            mode: 'checkbox', 
            clickToSelect: true, 
            hideSelectColumn: true,
            onSelect: (row, isSelect, rowIndex, e) => {
              if (e.target.tagName.toLowerCase() === 'img'){
                //console.log('onSelect');
                e.stopPropagation(); //dont check
                this.setState({
                  selectedImageUrl : e.target.src,
                  displayLargeImageModal:true});
                
                return;
            }
          }}}
          { ...props.baseProps }
          pagination={ paginationFactory(paginationOption) }
        />
      </div>
    )
  }</ToolkitProvider>

      </div>


    )

    
  }

  cleanSelectedCheckboxes=()=>{
    //The table is using the selected items array with 
    // in this state object and the key field to determine what is selected
    this.setState({selectedRows: []});
   
  }
  customTextFilter =()=>{
    if (this.state.useColumnFilters){
      return(
        textFilter(
          {
            delay: 600, // default is 500ms
            style: {
              backgroundColor: 'white'
            },
            className: 'form-control form-control-sm',
            placeholder: '',
           // onClick: e => console.log(e)
          }
        )
      )
    } else{
      return null;
    }   
   
  }

  customNumberFilter=()=>{
    if (this.state.useColumnFilters){
    return(
      numberFilter(
        {
          delay: 600, // default is 500ms
          style: {
            backgroundColor: 'white'
          },
          withoutEmptyComparatorOption: true,
          //comparators: [Comparator.EQ, Comparator.GT, Comparator.LT],
          className: 'custom-numberfilter-class',
          comparatorClassName: 'form-control form-control-sm',
          numberClassName: ' form-control-sm',
          placeholder: '',
          //onClick: e => console.log(e)
        }
      )
    )
      }else{
        return null
      }

  }

 
  formatLongString=(val)=>{
    return (
      <span style={{width:'190px', wordWrap:'break-word', display:'inline-block'}}>{val}</span>   
      
       )
  }

  formatCurrency=(val)=>{
    if (!Number.isNaN(val) && val >0){
     return LostItemFunctions.formatMoney(val)
    }else{
      return null;
    }
  }

  formatIsPaid=(cell,row)=>{
  if (row){
    if (row.isPaid===true){
      return (
        <div>
          <span className="badge badge-pill badge-success">Paid</span>
          <br/>
          <span className="">{this.formatCurrency(row.paidAmount)}</span>
          <br/>
          <span className="text-left">{LostItemFunctions.formatDateTime(row.paidAt)}</span>
        </div>
      )
    }
    
   }
}
  getColumns=()=>{
    return [
       { dataField: 'id', text: 'Picture', hidden:(this.state.hideImages), formatter: imageFormat,align: 'center', headerStyle: {width:'180px',  overflow: "hidden", textOverflow: 'ellipsis'} },
       { dataField: 'statusCd', sort: true, text: 'Status', align: 'center',formatter: statusFormatter,textAlign: 'center', style:{cursor: 'pointer'}, headerStyle: {width:'180px', overflow: "hidden", textAlign: 'center'} },
       { dataField: 'recipient',classes:'text-primary', sort: true, text: 'Recipient',filter: this.customTextFilter(), filterable:true, style:{fontWeight:'bold', cursor: 'pointer'},  textAlign: 'left', headerStyle: {width:'250px', overflow: "hidden", textOverflow: 'ellipsis'} },
       { dataField: 'roomNumber',classes:'text-primary', sort: true, text: 'Room#',filter: this.customTextFilter(), filterable:true,  textAlign: 'left',style:{cursor: 'pointer'}, headerStyle: {width:'120px', overflow: "hidden", textOverflow: 'ellipsis'} },
       { dataField: 'storageLocation',classes:'text-primary', sort: true, text: 'Storage', filter: this.customTextFilter(), filterable:true,  textAlign: 'left',style:{cursor: 'pointer'}, headerStyle: {width:'150px', overflow: "hidden", textOverflow: 'ellipsis'} },
       { dataField: 'groupName',classes:'text-primary', sort: true, text: 'Group Name', filter: this.customTextFilter(), filterable:true,  textAlign: 'left',style:{cursor: 'pointer'}, headerStyle: {width:'150px', overflow: "hidden", textOverflow: 'ellipsis'} },
       { dataField: 'booth',classes:'text-primary', sort: true, text: 'Booth', filter: this.customTextFilter(), filterable:true,  textAlign: 'left',style:{cursor: 'pointer'}, headerStyle: {width:'150px', overflow: "hidden", textOverflow: 'ellipsis'} },
 
       { dataField: 'dateReceived',sort: true,formatter: LostItemFunctions.formatDateTime, classes:'text-primary', text: 'Received', style:{cursor: 'pointer'}, headerStyle: { width: '180px', textAlign: 'center', overflow: "hidden", textOverflow: 'ellipsis' }},  
      { dataField: 'age',sort: true, textAlign: 'center',align: 'center', text: 'Age',  style:{cursor: 'pointer'}, filter: this.customNumberFilter(), headerStyle: {width:'250px', overflow: "hidden", textAlign: 'center',textOverflow: 'ellipsis'}, },  
      { dataField: 'guestPickupDate',sort: true,formatter: LostItemFunctions.formatDateTime, classes:'text-primary', style:{cursor: 'pointer'}, text: 'Pickup Dt.', headerStyle: { width: '180px', textAlign: 'center', overflow: "hidden", textOverflow: 'ellipsis' }},  
      { dataField: 'parcelRef',classes:'text-primary', sort: true, text: 'Reference',filter: this.customTextFilter(), filterable:true, style:{cursor: 'pointer'}, textAlign: 'left',headerStyle: { width:'140px',overflow: "hidden", textOverflow: 'ellipsis'} },
      
      { dataField: 'barcodeValue',classes:'text-primary',formatter:this.formatLongString, sort: true, text: 'Tracking',filter: this.customTextFilter(), filterable:true, style:{cursor: 'pointer', wordWrap: 'break-word', display:'inline-block'}, textAlign: 'left',headerStyle: { width:'220px',overflow: "hidden", textOverflow: 'ellipsis'} },

      { dataField: 'parcelGroupNum', sort: true, text: 'Parcel#', formatter:formatGroupNum, classes:'text-primary text-center', filterable:true, style:{cursor: 'pointer'}, textAlign: 'center', headerStyle: { width:'200px',overflow: "hidden", textOverflow: 'ellipsis'} },
      { dataField: 'labelText',sort: true,hidden:false, text: 'Label Information',filter: this.customTextFilter(),formatter:formatParcelLabel, style:{fontSize:12, cursor: 'pointer'},  textAlign: 'left', classes:'text-primary',headerStyle: (colum, colIndex) => {return { width: '320px', textAlign: 'center' }; } },
      { dataField: 'arrivalDate',sort: true,formatter: LostItemFunctions.formatDate, classes:'text-primary text-center', text: 'Arrival Dt.',style:{cursor: 'pointer'}, headerStyle: { width: '150px', textAlign: 'center', overflow: "hidden", textOverflow: 'ellipsis' }},  
      { dataField: 'departureDate',sort: true,formatter: LostItemFunctions.formatDate, classes:'text-primary text-center', text: 'Departure Dt.',style:{cursor: 'pointer'}, headerStyle: { width: '170px', textAlign: 'center', overflow: "hidden", textOverflow: 'ellipsis' }},  
  
      { dataField: 'serviceFee',sort: true,formatter: this.formatCurrency, filter:this.customNumberFilter(), textAlign: 'right',align: 'center', text: 'Handling Fee($)', style:{cursor: 'pointer', fontWeight:'bold'}, headerStyle: {width:'250px',overflow: "hidden", textAlign: 'center',textOverflow: 'ellipsis'}, },  
      { dataField: 'isPaid',sort: true,hidden:false, text: 'Payment', style:{fontSize:12, cursor: 'pointer'},formatter:this.formatIsPaid, textAlign: 'left', classes:'text-primary',headerStyle: (colum, colIndex) => {return { width: '220px', textAlign: 'center' }; } },

      { dataField: 'venueId',hidden:true, sort: true, text: 'venueId', classes:'text-primary' },
      { dataField: 'note',hidden:true, sort: true, text: 'venueId', classes:'text-primary' },
      { dataField: 'parcelSize',hidden:true, sort: true, text: 'venueId', classes:'text-primary' },
  
    ]
  }


// Changes the grid to the new grid with filters, checkboxes
renderAdvancedGrid=()=>{
  return (
  
    <div>
    {this.state.filteredItems === null && <p>Loading Parcels...</p>}
   
    <ToolkitProvider 
          bootstrap4
          keyField='id' 
          data={ this.state.filteredItems } 
          columns={ this.getColumns(this.state.venueTypeCd) } 
          
          defaultSorted={defaultSorted}
          search={ {
            searchFormatted: false
          } } 
         
        >
    {
      props => (
        <div>
           <SearchBar { ...props.searchProps } />
           <BootstrapTable
      className="table-sm"
      ref={this.tableRef}
      filter={ filterFactory({afterFilter}) }  
      striped
      hover
      condensed
     
      rowEvents={this.rowEvents}
      /*selectRow={ { 
            mode: 'checkbox', 
            clickToSelect: true, 
            hideSelectColumn: true,
            onSelect: (row, isSelect, rowIndex, e) => {
              if (e.target.tagName.toLowerCase() === 'img'){
                //console.log('onSelect');
                e.stopPropagation(); //dont check
                this.setState({
                  selectedImageUrl : e.target.src,
                  displayLargeImageModal:true});
                
                return;
            }
          }}}*/
      selectRow={ { 
        mode: 'checkbox', 
        clickToSelect: true, 
        selected:this.state.selectedRows,
    
        onSelect: (row, isSelect, rowIndex, e) => {
          if (e.target.tagName.toLowerCase() === 'img'){
            //console.log('onSelect');
            e.stopPropagation(); //dont check
            this.setState({
              selectedImageUrl : e.target.src,
              displayLargeImageModal:true});
              
            return;
          }

            let index = this.state.selectedRows.indexOf(row.id);  
            if (isSelect){
              if (index===-1) {
                this.state.selectedRows.push(row.id);
              }
            }else { this.state.selectedRows.splice(index, 1) }
          
          this.setState({
            checkedCount:this.state.selectedRows.length,
            actionButtonDisabled:(this.state.selectedRows.length===0)
          })
        },
        onSelectAll: (isSelect, rows, e) => {
          let selectedRowList = this.state.selectedRows;
          selectedRowList.length=0; //cleared
          //this.cleanSelectedCheckboxes();
          if (isSelect){
            // clear and loop and add each
            
            for(var i=0;i<rows.length; i++) { this.state.selectedRows.push(rows[i].id)}
          }else{
            this.setState({selectedRows:[]});
          }
          this.setState({
            checkedCount:this.state.selectedRows.length,
            actionButtonDisabled:(this.state.selectedRows.length===0)
          })
        },
        selectionRenderer: (props) => (
          <input
              style={{width:'20px', height:'20px', alignSelf:'center'}}
              type={props.mode}
              checked={props.checked}
              onChange={()=>{}}
          />
        )
   
      }}
    
     { ...props.baseProps }
     pagination={ paginationFactory(paginationOption) }
   />
        </div>

      )
      
      }
    </ToolkitProvider>

   

</div>

  )
}

handleAction=async(e)=>{
  
  let numChecked = this.state.selectedRows.length;
  let changeCd = e.target.value;
  if (changeCd===''){
    this.setState({changeCd:'', selectedAction:''});
    return
  }

  if ( numChecked>0){
    
    let confirmMsg= '';
    switch(changeCd){
      case 'A' : confirmMsg = 'Your about to archive ' + numChecked + ' parcels. Ok to continue?';break;
      case 'GP' : confirmMsg = 'Your about to return ' + numChecked + ' parcels. Ok to continue?';break;
      case 'I' : confirmMsg = 'Your about to return ' + numChecked + ' items back to inventory. Ok to continue?';break;
      case 'L' : confirmMsg = 'Your about to link ' + numChecked + ' items. Ok to continue?';break;
      
      default:confirmMsg='';
    }
    this.setState({changeCd:changeCd, selectedAction:changeCd});
    
    if (changeCd==='GP'){

      let parcelsToReturn = [];
      for (var i=0; i<this.state.selectedRows.length; i++){
        let item = this.state.filteredItems.find((item)=>{return item.id===this.state.selectedRows[i]});
        parcelsToReturn.push(item);

      };
      this.setState({parcelsToReturn: parcelsToReturn, displayReturnToGuest:true});
    }else if (changeCd==='A'){
      if (confirmMsg!=='' && window.confirm(confirmMsg)){
        this.batchUpdate(this.state.selectedRows, changeCd);
      }
    }else if (changeCd==='I'){
      if (confirmMsg!=='' && window.confirm(confirmMsg)){
        this.batchUpdate(this.state.selectedRows, changeCd);
      }
    }else if (changeCd==='L'){
      if (confirmMsg!=='' && window.confirm(confirmMsg)){
        this.batchlink(this.state.selectedRows);
      }
     
    }else if (changeCd==='BU'){
     
      this.setState({displayBatchUpdateModal:true});
      
    }else if (changeCd==='PS'){
      // handled printing the statement
      var params = this.state.selectedRows + '&tid=' + auth0Client.getIdToken() + '&vid=' + auth0Client.getActiveVenuedId();
      window.open(`${LOCAL_URL}/SRItem/PrintStatement/` + params, '_blank', 'menubar=1,toolbar=1');

    }else if (changeCd==='MAP'){
      //
      let parcelsToMarkAsPaid = [];
      for (var m=0; m<this.state.selectedRows.length; m++){
        let item = this.state.filteredItems.find((item)=>{return item.id===this.state.selectedRows[m]});
        parcelsToMarkAsPaid.push(item);

      };
      //console.log('parcelsToMarkAsPaid: ' + parcelsToMarkAsPaid);
      //console.log('parcelsToMarkAsPaid: ' + JSON.stringify(parcelsToMarkAsPaid));
      this.setState({parcelsToMarkAsPaid: parcelsToMarkAsPaid, displayMarkAsPaidModal:true});
  }else{
    alert("Check the items to update using the checkboxes for each row");
  }
}
}

renderMarkAsPaidModal=()=>{
  return(
    <Modal open={this.state.displayMarkAsPaidModal} onClose={()=>this.setState({displayMarkAsPaidModal:false})}>
      <h5>Mark As Paid</h5>
      <p>
        <div>
          <p>Enter the date you want to mark the selected parcels as paid.</p>
        </div>
      </p>
     
      <p>
        <DatePicker selected={this.state.paidDate} onChange={this.handlePaidDateChange} />
      </p>
     
      <p>
        <button className="btn btn-primary" onClick={this.handleMarkAsPaid}>Mark As Paid</button>
      </p>
    </Modal>
  )
} 

handlePaidDateChange=(date)=>{
  this.setState({paidDate:date});
}

handleMarkAsPaid=()=>{
  // Create an axios post to the endpoint /SR/batchMarkAsPaid
  // include authorization and venueid in headers


  axios.post(SERVER_URL + '/SR/batchMarkAsPaid', {
    ids: this.state.selectedRows,
    paidDate: this.state.paidDate
  }, {
    headers: {
      'Authorization': `Bearer ${auth0Client.getIdToken()}`,
      'venueId': auth0Client.getActiveVenuedId()
    }
  }).then((res)=>{
    console.log(res);
    this.setState({displayMarkAsPaidModal:false});
    this.loadSRItems();
  }).catch((e)=>{
    console.log(e);
    ToastStore.error("An error occured. " + e.message);
  });
}

batchUpdateFields=()=>{
  if (!this.state.selectedRows || this.state.selectedRows.length===0){
    alert('No rows selected');
    return;
  }
}


batchlink=(selectedRows)=>{ 
  if (selectedRows.length<=0){
    alert('no parcels selected');
    return;
  }

  let ids = [];
  for (var i=0; i<selectedRows.length; i++){
    ids.push(selectedRows[i]._id);
  }
  axios.post(SERVER_URL +  '/SR/link',{
    ids:ids,
  
   }, 
   {
    headers: { 
      'Authorization': `Bearer ${auth0Client.getIdToken()}`,
      'venueId': auth0Client.getActiveVenuedId() 
    }
  }).then((res)=>{
    
    if (res.status !== 200) {
      //place your reentry code
      console.log(res);
      ToastStore.error("An error occured. Please try again :" + res.body);
     
     }else{
      ToastStore.success('Parcel(s) Saved Successfully!');
      this.setState({batchUpdatedNote:'', displayReturnToGuest:false});
      this.loadSRItems();
     }


    // reload
     

    }).catch((e)=>{ 
      //console.log("error " + e)
      ToastStore.error("An error occured. " + e.message);
    });


}

renderStandardView=()=>{
    return(
          <div >
                  <div className='row'>
                    <div className='col'> <h3>Parcel: Receiving </h3></div>
                    <div className='col-4 text-right'>
                    <Toggle id='expensive' labelRight="Column Filters" checked={this.state.useColumnFilters} onToggle={value => this.setState({useColumnFilters:value}, ()=>{ 
                      if (cookies){
                        //console.log('setting user cooke:' + filter);
                        cookies.set('useParcelColumnFilters', this.state.useColumnFilters);
                      }
                    })} /> 
                    </div>
                    <div className='col-2 text-right'>
                    <Toggle id='hideImages' labelRight="Hide Images" checked={this.state.hideImages} onToggle={value => this.setState({hideImages:value}, ()=>{ 
                      if (cookies){
                        //console.log('setting user cooke:' + filter);
                        cookies.set(HIDE_IMAGES_COOKIE, this.state.hideImages);
                      }
                    })} /> 
                    </div>

                  </div>
               
                <div className='row'>
                    <div className='col-10  text-right'>
                        <div className="btn-group btn-group-toggle d-flex flex-row-reverse" role="group">
                        <div className="p-1"><button type="button" name="options" className={(this.state.filter==='A')?  "btn btn-gray btn-sm" :  "btn btn-outline-gray btn-sm"}  id="optArchive" onClick={this.filterButtonClick} >Archive </button></div>
                              <div className="p-1"><button type="button" name="options" className={(this.state.filter==='SB')? "btn btn-success btn-sm" : "btn btn-outline-success btn-sm"}  id="optShippedBack" onClick={this.filterButtonClick} >Shipped Back </button></div>
                              <div className="p-1"><button type="button" name="options" className={(this.state.filter==='D')? "btn btn-success btn-sm" : "btn btn-outline-success btn-sm"} id="optDelivered" onClick={this.filterButtonClick} >Delivered </button></div>
                              <div className="p-1"><button type="button" name="options" className={(this.state.filter==='GP')? "btn btn-success btn-sm":"btn btn-outline-success btn-sm"}  id="optGuestReturn" onClick={this.filterButtonClick} >Returned </button></div>
                              <div className="p-1"><button type="button" name="options" className={(this.state.filter==='I')?"btn btn-info btn-sm": "btn btn-outline-info btn-sm" }  id="optInStorage" onClick={this.filterButtonClick} >In Storage</button></div>
                              <div className="p-1"><button type="button" name="options" className={(this.state.filter==='')? "btn btn-primary btn-sm" :"btn btn-outline-primary btn-sm"}  id="optAll" onClick={this.filterButtonClick} >All </button></div>
                              <div className="p-1"><button className="btn btn-primary btn-sm"  onClick={this.loadSRItems} >{this.state.refreshButtonText}</button></div>
                        </div>
                       
                      
                    </div>
                
                        <div className='col-2 text-right'>
                       {this.state.supportActions && <select className='custom-select alert-success' style={{width:'230px'}} disabled={(this.state.actionButtonDisabled || auth0Client.ptReadOnly===true)}  name='action' onChange={this.handleAction} placeholder='Actions' >
                              <option value="">Select Action ({this.state.selectedRows.length + ' parcels)'})</option>
                              <option value="A">Archive Items... </option>
                              <option value="MAP">Mark As Paid...</option>
                              <option value="I">Move to inventory...</option>
                              <option value="GP">In-Person Return...</option>
                              <option value="PS">Print Statement...</option>
                              <option value="BU">Update Group & Reference...</option>
                           </select>

                      }
                      </div>
                     

                  
                    
                </div>
                
                    {this.renderGrid()}
                    {this.renderLargeImage()}
                    {(this.state.acceptParcelPayment) ? this.renderParcelPayment() : this.renderGuestPickup() }
                    {this.renderToast()}
                    {this.renderLinkOptions()}
                    {this.renderBatchUpdateFields()}
                    {this.renderMarkAsPaidModal()}
                </div>

    )

}

renderPaymentSupportedView=()=>{
            return(
            
              <Tabs>
                <TabList>
                  <Tab><p className='text-info'><b>Parcels</b></p></Tab>
                  {(this.state.acceptParcelPayment) && <Tab><p className='text-info'><b>Parcel Payment Manager</b></p></Tab>}
                </TabList>
                <TabPanel>
  
                <div>
                    <div className='row'>
                      <div className='col-10'> <h3>Parcel: Receiving </h3></div>
                      <div className='col-1 text-right'>
                      <Toggle id='expensive' labelRight="Column Filters" checked={this.state.useColumnFilters} onToggle={value => this.setState({useColumnFilters:value}, ()=>{ 
                        if (cookies){
                          //console.log('setting user cooke:' + filter);
                          cookies.set('useParcelColumnFilters', this.state.useColumnFilters);
                        }
                      })} /> 
                      </div>
                      <div className='col-1 text-right'>
                          <Toggle id='displayImagesToggle' labelRight="Hide Images" checked={this.state.hideImages} onToggle={value => this.setState({hideImages:value}, ()=>{ 
                            if (cookies){
                              //console.log('setting user cooke:' + filter);
                              cookies.set(HIDE_IMAGES_COOKIE, this.state.hideImages);
                            }
                          })} /> 
                    </div>
                    </div>

                  <div className='row'>
                      <div className='col-10  text-right'>
                          <div className="btn-group btn-group-toggle d-flex flex-row-reverse" role="group">
                              <div className="p-1"><button type="button" name="options" className={(this.state.filter==='A')?  "btn btn-gray btn-sm" :  "btn btn-outline-gray btn-sm"}  id="optArchive" onClick={this.filterButtonClick} >Archive </button></div>
                              <div className="p-1"><button type="button" name="options" className={(this.state.filter==='SB')? "btn btn-success btn-sm" : "btn btn-outline-success btn-sm"}  id="optShippedBack" onClick={this.filterButtonClick} >Shipped Back </button></div>
                              <div className="p-1"><button type="button" name="options" className={(this.state.filter==='D')? "btn btn-success btn-sm" : "btn btn-outline-success btn-sm"} id="optDelivered" onClick={this.filterButtonClick} >Delivered </button></div>
                              <div className="p-1"><button type="button" name="options" className={(this.state.filter==='GP')? "btn btn-success btn-sm":"btn btn-outline-success btn-sm"}  id="optGuestReturn" onClick={this.filterButtonClick} >Returned </button></div>
                              <div className="p-1"><button type="button" name="options" className={(this.state.filter==='I')?"btn btn-info btn-sm": "btn btn-outline-info btn-sm" }  id="optInStorage" onClick={this.filterButtonClick} >In Storage</button></div>
                              <div className="p-1"><button type="button" name="options" className={(this.state.filter==='')? "btn btn-primary btn-sm" :"btn btn-outline-primary btn-sm"}  id="optAll" onClick={this.filterButtonClick} >All </button></div>
                              <div className="p-1"><button className="btn btn-primary btn-sm"  onClick={this.loadSRItems} >{this.state.refreshButtonText}</button></div>
                          </div>
                        
                        
                      </div>

                          <div className='col-2 text-right'>
                        {
                         (this.state.enablePTBulkUpdates) && <select className='custom-select alert-success' value={this.state.selectedAction} style={{width:'230px'}} disabled={(this.state.actionButtonDisabled || auth0Client.ptReadOnly===true)}  name='action' onChange={this.handleAction} placeholder='Actions' >
                                <option value="">Select Action ({this.state.selectedRows.length + ' parcels)'})</option>
                                <option value="A">Archive Items... </option>
                                <option value="MAP">Mark As Paid...</option>
                                <option value="I">Move to inventory...</option>
                               {(this.state.acceptParcelPayment) && <option value="GP">Return + Request Payment...</option>}  
                               <option value="PS">Print Statement...</option>
                                <option value="BU">Update Group & Reference...</option>
                               
                               
                            
                            </select>
                        }
                        </div>
                      

                    
                          
                      </div>

                          {this.renderAdvancedGrid()}
                          {this.renderLargeImage()}
                          {(this.state.acceptParcelPayment) ? this.renderParcelPayment() : this.renderGuestPickup() }
                          {this.renderToast()}
                          {this.renderLinkOptions()}
                          {this.renderBatchUpdateFields()}
                          {this.renderMarkAsPaidModal()}
                  </div>
                </TabPanel>
                <TabPanel>
                                     
                      {this.renderPaymentManager()}
                </TabPanel>              
                  
                  
                  
              </Tabs>
            
            
            
            
          
)

}

renderPaymentManager=()=>{
  return(
    <div>
      <h5>Parcel Payment Manager</h5>
      <ParcelPaymentManager />
    </div>
  )
}



render(){
           return(
            <div className='container-fluid'>  
                 {(this.state.supportActions) ? this.renderPaymentSupportedView() : this.renderStandardView()};
            </div>
           )
       }
       }


export default withRouter(SRItems);